import axios from 'axios';
import config from '@/vue-caas/config/config.js';
import {
  isEmptyProcessWindowList,
  changeProcessShareFlag,
  compareTableData,
} from '@/vue-caas/utils/process';

const setupURI = config.setupApiUrl;
const baseURI = config.companyApiUrl;

const dbAdapterModule = {
  state: {
    dbAdapterList: [],
    dbAdapter: {},
    dbAdapterMapper: {},
    dbAdapterConfigList: {},
    dbInstanceList: [],
    dbInsTypeList: [],
    interfaceControlTableList: [],
    interfaceColumnList: [],
    dbMapperAdapterList: [],
    dbMapperAdapterSelectList: [],
    agentAdapterList: [],
    dataSet01Source: [],
    searchBy: {},
    dbConfigId: '',
    dbMapperId: '',
    resultXMLValidate: {},
    dataDBASelectBox: [],
    dbMapperAdapterItem: {},
    resultTestDbAdapter: null,
    dbAdapterMapperHistoryList: [],
    dbAdapterMapperDatarows: [],
    dbAdapterChange: {},
  },
  mutations: {
    SET_STORE_DB_ADAPTER_LIST(state, dbAdapterList) {
      if (
        JSON.stringify(state.dataSet01Source) !== JSON.stringify(dbAdapterList) &&
        !isEmptyProcessWindowList()
      ) {
        changeProcessShareFlag('DBA');
      }

      state.dbAdapterList = dbAdapterList;
      state.dataSet01Source = dbAdapterList;
    },
    SET_STORE_DB_ADAPTER_SELECT_BOX_LIST(state, dataDBASelectBox) {
      state.dbAdapterChange = compareTableData(
        state.dataDBASelectBox,
        dataDBASelectBox,
        'dba_child_id'
      );
      state.dataDBASelectBox = dataDBASelectBox.map((item) => {
        return {
          ...item,
          text: item.dba_name,
          value: item.dba_child_id,
        };
      });
    },
    SET_STORE_DB_ADAPTER_ID(state, id) {
      if (!isEmptyProcessWindowList()) {
        changeProcessShareFlag('DBA');
      }
    },
    SET_STORE_RESULT_VALIDATE(state, resultXMLValidate) {
      state.resultXMLValidate = resultXMLValidate;
    },
    SET_STORE_ADAPTER(state, dbAdapter) {
      state.dbAdapter = dbAdapter;
    },
    SET_STORE_ADAPTER_MAPPER(state, dbAdapterMapper) {
      state.dbAdapterMapper = dbAdapterMapper;
    },
    SET_STORE_DBCONFIG_ID(state, dbConfigId) {
      state.dbConfigId = dbConfigId.toString();
    },
    SET_STORE_DB_MAPPER_ID(state, dbMapperId) {
      state.dbMapperId = dbMapperId.toString();
    },
    SET_STORE_INTERFACE_COLUMN_LIST(state, interfaceColumnList) {
      state.interfaceColumnList = interfaceColumnList;
    },
    SET_STORE_DB_ADAPTER_CONFIG_LIST(state, dbAdapterConfigList) {
      let dbInstance = [];
      for (let i = 0; i < dbAdapterConfigList.length; i += 1) {
        let temp = {
          text: dbAdapterConfigList[i].config_name,
          value: dbAdapterConfigList[i].config_id,
          numofuse: dbAdapterConfigList[i].numofuse,
        };
        dbInstance.push(temp);
      }
      state.dbAdapterConfigList = dbInstance;
    },
    SET_STORE_AGENT_DBLIST(state, dbListSelectBox) {
      let dbInstance = [];
      let interfaceControlTable = [];
      let dbInsType = [];
      for (let i = 0; i < dbListSelectBox.length; i += 1) {
        let tmp1 = {
          text: dbListSelectBox[i].dbInstance,
          value: dbListSelectBox[i].dbInstance,
        };
        let tmp2 = { text: dbListSelectBox[i].dbTable, value: dbListSelectBox[i].dbTable };
        let tmp3 = {
          text: `${dbListSelectBox[i].dbInstance} (${dbListSelectBox[i].agentNm})`,
          value: dbListSelectBox[i].dbInfoId,
          dbInstance: dbListSelectBox[i].dbInstance,
        };
        dbInstance.push(tmp1);
        interfaceControlTable.push(tmp2);
        dbInsType.push(tmp3);
      }
      state.dbInstanceList = [...new Set(dbInstance)];
      state.dbInsTypeList = [...new Set(dbInsType)];
      state.interfaceControlTableList = [...new Set(interfaceControlTable)];
    },
    SET_STORE_DB_MAPPER_ITEM(state, dbMapperAdapterItem) {
      state.dbMapperAdapterItem = dbMapperAdapterItem;
    },
    SET_STORE_DB_MAPPER_LIST(state, dbMapperAdapterList) {
      let dbMapperList = [];
      for (let i = 0; i < dbMapperAdapterList.length; i += 1) {
        let tmp = dbMapperAdapterList[i];
        tmp.text = dbMapperAdapterList[i].mapper_name;
        tmp.value = dbMapperAdapterList[i].mapper_name;
        dbMapperList.push(tmp);
      }
      state.dbMapperAdapterList = dbMapperList;
      state.dbAdapterMapperDatarows = dbMapperList;
      state.dbMapperAdapterSelectList = [...new Set(dbMapperList)];
    },
    SET_STORE_AGENT_ADAPTER_LIST(state, agentAdapterList) {
      let agentList = [];
      for (let i = 0; i < agentAdapterList.length; i += 1) {
        const tmp = agentAdapterList[i];
        tmp.text = agentAdapterList[i].agentNm;
        tmp.value = agentAdapterList[i].agentId;
        agentList.push(tmp);
      }
      state.agentAdapterList = agentList;
    },
    SET_STORE_DB_ADAPTER_FILTER(state, searchBy) {
      let datarows = state.dataSet01Source;
      state.searchBy = searchBy;
      let filterBy = state.searchBy;
      let listResult = [];
      if (filterBy != null) {
        let searchBy = filterBy.searchBy;
        let str = filterBy.str;
        if (str.trim() == '') {
          listResult = datarows;
        }
        listResult = datarows.filter((item) => {
          if (searchBy == 'all') {
            for (const prop in item) {
              if (typeof item[prop] == 'string') {
                let propValue = item[prop].toLowerCase();
                let queryValue = str.toLowerCase();
                if (propValue.includes(queryValue)) {
                  return true;
                }
              } else if (typeof item[prop] == 'number') {
                let propValue = item[prop].toString().toLowerCase();
                let queryValue = str.toLowerCase();
                if (propValue.includes(queryValue)) {
                  return true;
                }
              }
            }
          } else {
            if (typeof item[searchBy] == 'string') {
              let propValue = item[searchBy].toLowerCase();
              let queryValue = str.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            } else if (typeof item[searchBy] == 'number') {
              let propValue = item[searchBy].toString().toLowerCase();
              let queryValue = str.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            }
          }

          return false;
        });
      }
      state.dbAdapterList = listResult;
    },
    SET_STORE_RESULT_TEST_DB_ADAPTER(state, resultTestDbAdapter) {
      state.resultTestDbAdapter = resultTestDbAdapter;
    },
    SET_STORE_DB_ADAPTER_MAPPER_HISTORY_LIST(state, dbAdapterMapperList) {
      state.dbAdapterMapperHistoryList = dbAdapterMapperList;
    },
    SET_DB_ADAPTER_MAPPER_FILTER(state, params) {
      let locked = params.locked;
      let search = params.search;
      let arrFilter = state.dbAdapterMapperDatarows;
      if (locked != undefined && locked != '') {
        arrFilter = arrFilter.filter((item) => {
          return item.lock_yn == locked;
        });
      }
      if (search != undefined && search != '') {
        arrFilter = arrFilter.filter((item) => {
          for (const prop in item) {
            if (
              prop == 'file_name' ||
              prop == 'lock_yn' ||
              prop == 'mapper_name' ||
              prop == 'upd_dt' ||
              prop == 'mapper_ver'
            ) {
              if (typeof item[prop] == 'string') {
                let propValue = item[prop].toLowerCase();
                let queryValue = search.toLowerCase();
                if (propValue.includes(queryValue)) {
                  return true;
                }
              } else if (typeof item[prop] == 'number') {
                let propValue = item[prop].toString().toLowerCase();
                let queryValue = search.toLowerCase();
                if (propValue.includes(queryValue)) {
                  return true;
                }
              }
            }
          }
        });
      }
      state.dbMapperAdapterList = arrFilter;
    },
  },
  actions: {
    getDBAdapterList: async ({ commit }, params) => {
      await axios
        .post(`${setupURI}/dbAdapter/list`, params)
        .then((response) => {
          commit('SET_STORE_DB_ADAPTER_LIST', response.data);
          commit('SET_STORE_DB_ADAPTER_SELECT_BOX_LIST', response.data);
        })
        .catch((ex) => {
          commit('SET_STORE_DB_ADAPTER_LIST', {});
          commit('SET_STORE_DB_ADAPTER_SELECT_BOX_LIST', {});
          throw ex;
        });
    },
    getAdapterId: async ({ commit }, params) => {
      try {
        const response = await axios.get(`${setupURI}/dbAdapterConfig/detail/${params.id}`);
        commit('SET_STORE_ADAPTER', response.data);
      } catch (err) {
        commit('SET_STORE_ADAPTER', {});
        throw err;
      }
    },
    getAdapterMapper: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${setupURI}/dbAdapter/dbMApper/detail`, params);
        commit('SET_STORE_ADAPTER_MAPPER', response.data);
      } catch (err) {
        commit('SET_STORE_ADAPTER_MAPPER', {});
        throw err;
      }
    },
    getDbAgentList: async ({ commit }) => {
      try {
        const response = await axios.get(`${baseURI}/agent/dbList`);
        commit('SET_STORE_AGENT_DBLIST', response.data);
      } catch (err) {
        commit('SET_STORE_AGENT_DBLIST', {});
        throw err;
      }
    },
    getDbAgentListByAgent: async ({ commit }, params) => {
      try {
        const response = await axios.get(
          `${baseURI}/agent/dbList/${params.agent_id}/${params.target_agent_id}`
        );
        commit('SET_STORE_AGENT_DBLIST', response.data);
      } catch (err) {
        commit('SET_STORE_AGENT_DBLIST', {});
        throw err;
      }
    },
    getDBAdapterConfigList: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${setupURI}/dbAdapterConfig/list`, params);
        commit('SET_STORE_DB_ADAPTER_CONFIG_LIST', response.data);
      } catch (err) {
        commit('SET_STORE_DB_ADAPTER_CONFIG_LIST', {});
        throw err;
      }
    },
    setFilterDBAdapter: async ({ commit }, searchBy) => {
      commit('SET_STORE_DB_ADAPTER_FILTER', searchBy);
    },
    getAgentAdapterList: async ({ commit }, params) => {
      await axios
        .post(`${baseURI}/agent/list`, params)
        .then((response) => {
          commit('SET_STORE_AGENT_ADAPTER_LIST', response.data);
        })
        .catch((ex) => {
          commit('SET_STORE_AGENT_ADAPTER_LIST', {});
          throw ex;
        });
    },
    getDBMapperAdapterList: async ({ commit }, params) => {
      await axios
        .post(`${setupURI}/dbAdapter/dbMapper/list`, params)
        .then((response) => {
          commit('SET_STORE_DB_MAPPER_LIST', response.data);
        })
        .catch((ex) => {
          commit('SET_STORE_DB_MAPPER_LIST', {});
          throw ex;
        });
    },
    getDBMapperAdapterDetail: async ({ commit }, params) => {
      await axios
        .post(`${setupURI}/dbAdapter/dbMapper/list`, params)
        .then((response) => {
          if (response.data) {
            commit('SET_STORE_DB_MAPPER_ITEM', response.data);
            commit('SET_STORE_DB_MAPPER_ID', response.data.mapper_id);
          } else {
            commit('SET_STORE_DB_MAPPER_ITEM', {});
            commit('SET_STORE_DB_MAPPER_ID', '');
          }
        })
        .catch((ex) => {
          commit('SET_STORE_DB_MAPPER_ITEM', {});
          commit('SET_STORE_DB_MAPPER_ID', '');
          throw ex;
        });
    },
    insertDBMapperAdapter: async ({ commit }, params) => {
      await axios
        .post(`${setupURI}/dbAdapter/dbMapper/insert`, params)
        .then((response) => {
          commit('SET_STORE_DB_MAPPER_ID', response.data);
        })
        .catch((ex) => {
          commit('SET_STORE_DB_MAPPER_ID', response.data);
          throw ex;
        });
    },
    deployDBMapperAdapter: async ({ commit }, params) => {
      await axios
        .post(`${setupURI}/dbAdapter/dbMapper/deploy`, params)
        .then((response) => {
          return response;
        })
        .catch((ex) => {
          throw ex;
        });
    },
    validateXML: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${setupURI}/dbAdapter/dbMapper/validate`, params);
        commit('SET_STORE_RESULT_VALIDATE', response.data);
      } catch (err) {
        commit('SET_STORE_RESULT_VALIDATE', null);
        throw err;
      }
    },
    getInterfaceColumnList: async ({ commit }, params) => {
      await axios
        .post(`${setupURI}/dbAdapterConfig/interfaceColumn`, params)
        .then((response) => {
          commit('SET_STORE_INTERFACE_COLUMN_LIST', response.data);
        })
        .catch((ex) => {
          commit('SET_STORE_INTERFACE_COLUMN_LIST', {});
          throw ex;
        });
    },
    selectQueryList: async ({ commit }, params) => {
      await axios
        .post(`${setupURI}/dbAdapterConfig/query/select`, params)
        .then((response) => {
          commit('SET_STORE_INTERFACE_COLUMN_LIST', response.data);
        })
        .catch((ex) => {
          commit('SET_STORE_INTERFACE_COLUMN_LIST', {});
          throw ex;
        });
    },
    manageQueryList: async ({ commit }, params) => {
      await axios
        .post(`${setupURI}/dbAdapterConfig/query/manage`, params)
        .then((response) => {})
        .catch((ex) => {
          throw ex;
        });
    },
    deleteDBAdapter: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${setupURI}/dbAdapter/delete`, params);
        commit('SET_STORE_DB_ADAPTER_ID', response.data);
        return response.data;
      } catch (err) {
        throw err;
      }
    },
    insertDBAdapter: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${setupURI}/dbAdapter/insert`, params);
        commit('SET_STORE_DB_ADAPTER_ID', response.data);
        return response.data;
      } catch (err) {
        throw err;
      }
    },
    updateDBAdapter: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${setupURI}/dbAdapter/update`, params);
        commit('SET_STORE_DB_ADAPTER_ID', response.data);
        return response.data;
      } catch (err) {
        throw err;
      }
    },
    insertDBAdapterConfig: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${setupURI}/dbAdapterConfig/insert`, params);
        commit('SET_STORE_DBCONFIG_ID', response.data);
      } catch (err) {
        throw err;
      }
    },
    updateDBAdapterConfig: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${setupURI}/dbAdapterConfig/update`, params);
        return response.data;
      } catch (err) {
        throw err;
      }
    },
    deleteDBAdapterConfig: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${setupURI}/dbAdapterConfig/delete`, params);
        return response.data;
      } catch (err) {
        throw err;
      }
    },
    testDbAdapterMapper: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${setupURI}/dbAdapter/dbMapper/test`, params);
        // console.log(response.data);
        commit('SET_STORE_RESULT_TEST_DB_ADAPTER', response.data);
      } catch (err) {
        // console.log(ex);
        // alert(err);
        commit('SET_STORE_RESULT_TEST_DB_ADAPTER', null);
        throw err;
      }
    },
    dbAapterMapperUpdateLock: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${setupURI}/dbAdapter/dbMapper/unlock`, params);
      } catch (err) {
        throw err;
      }
    },
    dbAapterMapperHistory: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${setupURI}/dbAdapter/dbMapper/history/list`, params);
        commit('SET_STORE_DB_ADAPTER_MAPPER_HISTORY_LIST', response.data);
      } catch (err) {
        commit('SET_STORE_DB_ADAPTER_MAPPER_HISTORY_LIST', []);
        throw err;
      }
    },
    changeDbAdapterMapperVersionHistory: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${setupURI}/dbAdapter/dbMapper/history/save`, params);
      } catch (err) {
        throw err;
      }
    },
    dbAdapterMapperCheckOut: async ({ commit }, params) => {
      try {
        const response = await axios.post(
          `${setupURI}/dbAdapter/dbMapper/history/checkout`,
          params
        );
      } catch (err) {
        throw err;
      }
    },
    checkDBConfig: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${setupURI}/dbAdapterConfig/checkDBConfig`, params);
        return response.data;
      } catch (err) {
        throw err;
      }
    },
    deleteDBAdapterMapperHistory: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${setupURI}/dbAdapter/dbMapper/history/delete`, params);
      } catch (err) {
        throw err;
      }
    },
    deleteDBAdapterMapper: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${setupURI}/dbAdapter/dbMapper/delete`, params);
        return response.data;
      } catch (err) {
        throw err;
      }
    },
  },
  getters: {
    dbAdapter: (state) => state.dbAdapter,
    dbConfigId: (state) => state.dbConfigId,
    dbMapperId: (state) => state.dbMapperId,
    dbAdapterList: (state) => state.dbAdapterList,
    dbAdapterMapper: (state) => state.dbAdapterMapper,
    dataDBASelectBox: (state) => state.dataDBASelectBox,
    dbMapperAdapterList: (state) => state.dbMapperAdapterList,
    dbMapperAdapterSelectList: (state) => state.dbMapperAdapterSelectList,
    agentAdapterList: (state) => state.agentAdapterList,
    dbInstanceList: (state) => state.dbInstanceList,
    dbInsTypeList: (state) => state.dbInsTypeList,
    interfaceColumnList: (state) => state.interfaceColumnList,
    dbAdapterConfigList: (state) => state.dbAdapterConfigList,
    resultXMLValidate: (state) => state.resultXMLValidate,
    interfaceControlTableList: (state) => state.interfaceControlTableList,
    dbMapperAdapterItem: (state) => state.dbMapperAdapterItem,
    resultTestDbAdapter: (state) => state.resultTestDbAdapter,
    dbAdapterMapperHistoryList: (state) => state.dbAdapterMapperHistoryList,
    dbAdapterChange: (state) => state.dbAdapterChange,
  },
};
export default dbAdapterModule;
